import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

import Home from '../views/_pisa/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'PISA-Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/_pisa/Login.vue'),
  },
  // admin
  {
    path: '/admin',
    name: 'admin',
    redirect: '/admin/rights',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/admin/rights',
        name: 'Rights',
        icon: 'mdi-account-key-outline',
        component: () => import('../views/_pisa/admin/Rights.vue'),
      },
      {
        path: '/admin/apps',
        name: 'Apps',
        icon: 'mdi-application',
        component: () => import('../views/_pisa/admin/Apps.vue'),
        meta: { title: 'Application' },
      },
      {
        path: '/admin/user',
        name: 'User',
        icon: 'mdi-account-edit-outline',
        component: () => import('../views/_pisa/admin/User.vue'),
      },
      {
        path: '/admin/statistic',
        name: 'Statistic',
        icon: 'mdi-chart-bar',
        component: () => import('../views/_pisa/admin/Statistic.vue'),
      },
      {
        path: '/admin/maillog',
        name: 'MailLog',
        icon: 'mdi-email-outline',
        component: () => import('../views/_pisa/admin/MailLog.vue'),
        meta: { search: true },
      },
      {
        path: '/admin/info',
        name: 'Info',
        icon: 'mdi-information-outline',
        component: () => import('../views/_pisa/admin/Info.vue'),
      },
      {
        path: '/admin/test',
        name: 'Test',
        icon: 'mdi-bug-outline',
        component: () => import('../views/_pisa/admin/Test.vue'),
      },
    ],
  },
  // crm
  {
    path: '/crm',
    name: 'crm',
    redirect: '/crm/overview',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/crm/request/:id',
        name: 'neuer Antrag',
        icon: 'mdi-file-outline',
        component: () => import('../views/crm/Request.vue'),
        meta: { title: 'Antrag' },
      },
      {
        path: '/crm/overview',
        name: 'Übersicht',
        icon: 'mdi-format-align-justify',
        component: () => import('../views/crm/Overview.vue'),
        meta: { search: true },
      },
      {
        path: '/crm/tools',
        name: 'Tools',
        icon: 'mdi-tools',
        redirect: '/crm/tools/search',
        component: () => import('../components/Dropdown.vue'),
        meta: { right: 4 },
        children: [
          {
            path: '/crm/tools/search',
            name: 'Suche',
            icon: 'mdi-magnify',
            component: () => import('../views/crm/Search.vue'),
            meta: { search: true },
          },
          {
            path: '/crm/tools/history',
            name: 'Gerätehistory',
            icon: 'mdi-history',
            component: () => import('../views/crm/History.vue'),
            meta: { search: true },
          },
          {
            path: '/crm/tools/rohs',
            name: 'Struktur (RoHS)',
            icon: 'mdi-format-align-left',
            redirect: '/draw/ressource',
          },
          {
            path: '/crm/tools/statistic',
            name: 'Statistik',
            icon: 'mdi-chart-bar',
            component: () => import('../views/crm/Statistic.vue'),
          },
          {
            path: '/crm/tools/revlist',
            name: 'Erzeugnisstand',
            icon: 'mdi-file',
            component: () => import('../views/crm/Revlist.vue'),
            meta: { right: 8 },
          },
        ],
      },
      {
        path: '/crm/options',
        name: 'Optionen',
        icon: 'mdi-cog',
        component: () => import('../views/crm/Options.vue'),
        meta: { right: 1 },
      },
    ],
  },
  // draw
  {
    path: '/draw',
    name: 'draw',
    redirect: '/draw/drawing',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/draw/drawing',
        name: 'Zeichnungen',
        icon: 'mdi-file-outline',
        component: () => import('../views/draw/Drawing.vue'),
        meta: { search: true, multiple: true },
      },
      {
        path: '/draw/ressource',
        name: 'Stücklisten',
        icon: 'mdi-format-align-left',
        component: () => import('../views/draw/Ressource.vue'),
        meta: { right: 4, search: true },
      },
      {
        path: '/draw/paintlist',
        name: 'Lacklisten',
        icon: 'mdi-palette-advanced',
        component: () => import('../views/draw/Paintlist.vue'),
        meta: { right: 8, search: true, date: true },
      },
      {
        path: '/draw/check',
        name: 'Prüfung',
        icon: 'mdi-flash',
        component: () => import('../views/draw/Check.vue'),
        meta: { right: 16, search: true },
      },
      {
        path: '/draw/option',
        name: 'Optionen',
        icon: 'mdi-cog',
        component: () => import('../views/draw/Option.vue'),
        meta: { right: 32 },
      },
    ],
  },
  // elvira
  {
    path: '/elvira',
    name: 'elvira',
    redirect: '/elvira/mounting',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/elvira/planing',
        name: 'Planung',
        icon: 'mdi-pencil',
        component: () => import('../views/elvira/Planing.vue'),
        meta: { right: 6, search: true },
      },
      {
        path: '/elvira/mounting',
        name: 'Montage',
        icon: 'mdi-view-comfy',
        component: () => import('../views/elvira/Mounting.vue'),
        meta: { right: 8, search: true },
      },
      {
        path: '/elvira/shipping',
        name: 'Versand',
        icon: 'mdi-cube-send',
        component: () => import('../views/elvira/Shipping.vue'),
        meta: { right: 64 },
      },
      {
        path: '/elvira/evaluation',
        name: 'Auswertung',
        icon: 'mdi-chart-bar',
        component: () => import('../views/elvira/Evaluation.vue'),
        meta: { right: 128 },
      },
    ],
  },
  // fpm
  {
    path: '/fpm',
    name: 'fpm',
    redirect: '/fpm/mounting',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/fpm/planing',
        name: 'Planung',
        icon: 'mdi-pencil',
        component: () => import('../views/fpm/Planing.vue'),
        meta: { right: 6, search: true }, // 4+2 for view only
      },
      {
        path: '/fpm/mounting',
        name: 'Montage',
        icon: 'mdi-view-comfy',
        component: () => import('../views/fpm/Mounting.vue'),
        meta: { right: 8, search: true },
      },
      {
        path: '/fpm/shipping',
        name: 'Versand',
        icon: 'mdi-cube-send',
        component: () => import('../views/fpm/Shipping.vue'),
        meta: { right: 64 },
      },
      {
        path: '/fpm/evaluation',
        name: 'Auswertung',
        icon: 'mdi-chart-bar',
        component: () => import('../views/fpm/Evaluation.vue'),
        meta: { right: 128 },
      },
    ],
  },
  // mess
  {
    path: '/mess',
    name: 'mess',
    redirect: '/mess/overview',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/mess/overview',
        name: 'Messmittel',
        icon: 'mdi-hammer-wrench',
        component: () => import('../views/mess/Overview.vue'),
        meta: { search: true },
      },
    ],
  },
  // noac
  {
    path: '/noac',
    name: 'noac',
    redirect: '/noac/inventory',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/noac/inventory',
        name: 'Bestand',
        icon: 'mdi-clipboard-text-outline',
        component: () => import('../views/noac/Inventory.vue'),
        meta: { search: true },
      },
      {
        path: '/noac/orders',
        name: 'Bestellungen',
        icon: 'mdi-list-box-outline',
        component: () => import('../views/noac/Orders.vue'),
        meta: { search: true },
      },
      {
        path: '/noac/ressource',
        name: 'Stücklisten',
        icon: 'mdi-format-align-left',
        component: () => import('../views/noac/ResourceList.vue'),
      },
      {
        path: '/noac/options',
        name: 'Optionen',
        icon: 'mdi-cog',
        component: () => import('../views/noac/Options.vue'),
        meta: { right: 8 },
      },
    ],
  },
  // otrs
  {
    path: '/otrs',
    name: 'otrs',
    redirect: '/otrs/ticket',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/otrs/ticket',
        name: 'GE - Ticket',
        icon: 'mdi-text-box-outline',
        component: () => import('../views/otrs/Ticket.vue'),
        meta: { right: 2 },
      },
      {
        path: '/otrs/option',
        name: 'Optionen',
        icon: 'mdi-cog',
        component: () => import('../views/otrs/Option.vue'),
        meta: { right: 4 },
      },
    ],
  },
  // pda
  {
    path: '/pda',
    name: 'pda',
    redirect: '/pda/archive',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/pda/archive',
        name: 'Archiv',
        icon: 'mdi-archive-outline',
        component: () => import('../views/pda/Archive.vue'),
        meta: { search: true, multiple: true },
      },
      {
        path: '/pda/import/:id',
        name: 'Import',
        icon: 'mdi-file-import-outline',
        component: () => import('../views/pda/Import.vue'),
        meta: { right: 4 },
      },
      {
        path: '/pda/info',
        name: 'Info',
        icon: 'mdi-information-outline',
        component: () => import('../views/pda/Changes.vue'),
      },
      {
        path: '/pda/options',
        name: 'Optionen',
        icon: 'mdi-cog',
        component: () => import('../views/pda/Options.vue'),
        meta: { right: 1 },
      },
    ],
  },
  // plan
  {
    path: '/plan',
    name: 'plan',
    redirect: '/plan/pausch',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/plan/pausch',
        name: 'Pausch',
        icon: 'mdi-chart-bar',
        component: () => import('../views/plan/Pausch.vue'),
        meta: { right: 2 }, // 8+2 for calc only
      },
      {
        path: '/plan/overview',
        name: 'Übersicht',
        icon: 'mdi-view-day-outline',
        component: () => import('../views/plan/Overview.vue'),
        meta: { right: 2 },
      },
      {
        path: '/plan/invoice',
        name: 'Rechnungen',
        icon: 'mdi-format-align-justify',
        component: () => import('../views/plan/Invoice.vue'),
        meta: { right: 2 },
      },
      {
        path: '/plan/contracts',
        name: 'Aufträge',
        icon: 'mdi-format-align-justify',
        component: () => import('../views/plan/Contracts.vue'),
        meta: { right: 2 },
      },
      {
        path: '/plan/goods',
        name: 'Wareneingang',
        icon: 'mdi-format-align-justify',
        component: () => import('../views/plan/Goods.vue'),
        meta: { right: 2 },
      },
      {
        path: '/plan/orders',
        name: 'Bestellungen',
        icon: 'mdi-format-align-justify',
        component: () => import('../views/plan/Orders.vue'),
        meta: { right: 2 },
      },
      {
        path: '/plan/tools',
        name: 'Tools',
        icon: 'mdi-tools',
        redirect: '/plan/tools/calc',
        component: () => import('../components/Dropdown.vue'),
        meta: { right: 28 },
        children: [
          {
            path: '/plan/tools/calc',
            name: 'Kalkulation',
            icon: 'mdi-calculator',
            component: () => import('../views/plan/Calculation.vue'),
            meta: { right: 8, search: true },
          },
          {
            path: '/plan/tools/material',
            name: 'Materialbestand',
            icon: 'mdi-format-align-justify',
            component: () => import('../views/plan/Materialstock.vue'),
            meta: { right: 4 },
          },
          {
            path: '/plan/tools/check',
            name: 'Kostencheck',
            icon: 'mdi-currency-eur',
            component: () => import('../views/plan/Costcheck.vue'),
            meta: { right: 4, search: true },
          },
          {
            path: '/plan/tools/payment',
            name: 'offene Rechnungen',
            icon: 'mdi-cash-clock',
            component: () => import('../views/plan/Payments.vue'),
            meta: { right: 16, search: true },
          },
          {
            path: '/plan/tools/facturx',
            name: 'X-Rechnungen',
            icon: 'mdi-file-xml-box',
            component: () => import('../views/plan/Facturx.vue'),
            meta: { right: 32, search: true },
          },
        ],
      },
    ],
  },
  // prm
  {
    path: '/prm',
    name: 'prm',
    redirect: '/prm/overview',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/prm/complaint/:id',
        name: 'neue Reklamation',
        icon: 'mdi-file-outline',
        component: () => import('../views/prm/Complaint'),
      },
      {
        path: '/prm/overview',
        name: 'Übersicht',
        icon: 'mdi-format-align-justify',
        component: () => import('../views/prm/Overview.vue'),
        meta: { search: true },
      },
      {
        path: '/prm/search',
        name: 'Suche',
        icon: 'mdi-magnify',
        component: () => import('../views/prm/Search.vue'),
        meta: { search: true, multiple: true },
      },
      {
        path: '/prm/tools',
        name: 'Tools',
        icon: 'mdi-tools',
        redirect: '/prm/tools/evaluation',
        component: () => import('../components/Dropdown.vue'),
        children: [
          {
            path: '/prm/toole/evaluation',
            name: 'Auswertung',
            icon: 'mdi-dots-vertical',
            component: () => import('../views/prm/Evaluation.vue'),
            meta: { search: true },
          },
          {
            path: '/prm/toole/statistic',
            name: 'Statistik',
            icon: 'mdi-chart-bar',
            component: () => import('../views/prm/Statistic.vue'),
            meta: { search: true },
          },
          {
            path: '/prm/tools/quarter',
            name: 'Quartalsübersicht',
            icon: 'mdi-view-column',
            component: () => import('../views/prm/Quarter.vue'),
          },
        ],
      },
      {
        path: '/prm/options',
        name: 'Optionen',
        icon: 'mdi-cog',
        component: () => import('../views/prm/Options.vue'),
        meta: { right: 1, search: true },
      },
    ],
  },
  // psp
  {
    path: '/psp',
    name: 'psp',
    redirect: '/psp/planing',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/psp/planing',
        name: 'Planung',
        icon: 'mdi-notebook-outline',
        component: () => import('../views/psp/Planing.vue'),
        meta: { search: true },
      },
      {
        path: '/psp/overview',
        name: 'Übersicht',
        icon: 'mdi-view-headline',
        component: () => import('../views/psp/Overview.vue'),
        meta: { search: true },
      },
      {
        path: '/psp/documents',
        name: 'Dokumente',
        icon: 'mdi-view-grid-outline',
        component: () => import('../views/psp/Documents.vue'),
      },
    ],
  },
  // ptb
  {
    path: '/ptb',
    name: 'ptb',
    redirect: '/ptb/archive',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/ptb/archive',
        name: 'Archiv',
        icon: 'mdi-archive-outline',
        component: () => import('../views/ptb/archive/ArchiveSearch.vue'),
        meta: { right: 6, search: true, multiple: true },
      },
      {
        path: '/ptb/infor',
        name: 'Infor',
        icon: 'mdi-magnify',
        component: () => import('../views/ptb/search/SearchInfor.vue'),
        meta: { right: 8, search: true, multiple: true },
      },
      {
        path: '/ptb/logistic',
        name: 'Logistik',
        icon: 'mdi-invoice-list-outline',
        component: () => import('../views/ptb/logistic/LogisticSearch.vue'),
        meta: { right: 6 },
      },
      {
        path: '/ptb/prod',
        name: 'AV',
        icon: 'mdi-format-list-bulleted-type',
        redirect: '/ptb/prod/orders',
        component: () => import('../components/Dropdown.vue'),
        meta: { right: 16 },
        children: [
          {
            path: '/ptb/prod/orders',
            name: 'Bestellungen',
            icon: 'mdi-clipboard-list-outline',
            component: () => import('../views/ptb/prod/ProdOrders.vue'),
            meta: { search: true },
          },
          {
            path: '/ptb/prod/wip',
            name: 'WIP',
            icon: 'mdi-progress-question',
            component: () => import('../views/ptb/prod/ProdWip.vue'),
            meta: { search: true },
          },
          {
            path: '/ptb/prod/mpos',
            name: 'M-Pos',
            icon: 'mdi-text-box-check-outline',
            component: () => import('../views/ptb/prod/ProdMpos.vue'),
            meta: {},
          },
          {
            path: '/ptb/prod/missing',
            name: 'Fehlteile',
            icon: 'mdi-text-box-minus-outline',
            component: () => import('../views/ptb/prod/ProdMissing.vue'),
            meta: { search: true },
          },
          {
            path: '/ptb/prod/need',
            name: 'Bedarfsprüfung',
            icon: 'mdi-calculator',
            component: () => import('../views/ptb/prod/ProdNeed.vue'),
            meta: { search: true },
          },
          {
            path: '/ptb/prod/inventory',
            name: 'Materialbestand',
            icon: 'mdi-format-align-justify',
            component: () => import('../views/ptb/prod/ProdInventory.vue'),
            meta: { search: true },
          },
        ],
      },
      // {
      //   path: '/ptb/prod',
      //   name: 'AV',
      //   icon: 'mdi-format-list-bulleted-type',
      //   redirect: '/ptb/prod/orders',
      //   component: () => import('../components/Dropdown.vue'),
      //   meta: { right: 16 },
      //   children: [
      //     {
      //       path: '/ptb/prod/orders',
      //       name: 'Bestellungen',
      //       icon: 'mdi-clipboard-list-outline',
      //       component: () => import('../views/ptb/prod/ProdOrders.vue'),
      //       meta: { search: true },
      //     },
      //     {
      //       path: '/ptb/prod/wip',
      //       name: 'WIP',
      //       icon: 'mdi-progress-question',
      //       component: () => import('../views/ptb/prod/ProdWip.vue'),
      //       meta: { search: true },
      //     },
      //     {
      //       path: '/ptb/prod/mpos',
      //       name: 'M-Pos',
      //       icon: 'mdi-text-box-check-outline',
      //       component: () => import('../views/ptb/prod/ProdMpos.vue'),
      //       meta: {},
      //     },
      //     {
      //       path: '/ptb/prod/missing',
      //       name: 'Fehlteile',
      //       icon: 'mdi-text-box-minus-outline',
      //       component: () => import('../views/ptb/prod/ProdMissing.vue'),
      //       meta: { search: true },
      //     },
      //     {
      //       path: '/ptb/prod/need',
      //       name: 'Bedarfsprüfung',
      //       icon: 'mdi-calculator',
      //       component: () => import('../views/ptb/prod/ProdNeed.vue'),
      //       meta: { search: true },
      //     },
      //   ],
      // },
      {
        path: '/ptb/options',
        name: 'Optionen',
        icon: 'mdi-cog',
        component: () => import('../views/ptb/Options.vue'),
        meta: { right: 32 },
      },
    ],
  },
  // ptm
  {
    path: '/ptm',
    name: 'ptm',
    redirect: '/ptm/userview',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/ptm/userview',
        name: 'Übersicht',
        icon: 'mdi-account-outline',
        component: () => import('../views/ptm/Userview.vue'),
        meta: { search: true },
      },
      {
        path: '/ptm/options',
        name: 'Optionen',
        icon: 'mdi-cog',
        component: () => import('../views/ptm/Options.vue'),
        meta: { right: 1 },
      },
    ],
  },
  // qmd
  {
    path: '/qmd',
    name: 'qmd',
    redirect: '/qmd/overview',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/qmd/overview',
        name: 'Übersicht',
        icon: 'mdi-view-grid',
        component: () => import('../views/qmd/Overview.vue'),
        meta: { search: true },
      },
      {
        path: '/qmd/list',
        name: 'Liste',
        icon: 'mdi-menu',
        component: () => import('../views/qmd/List.vue'),
        meta: { search: true },
      },
      {
        path: '/qmd/evaluation',
        name: 'Fehlerauswertung',
        icon: 'mdi-chart-bar',
        component: () => import('../views/qmd/Evaluation.vue'),
        meta: { right: 4 },
      },
      {
        path: '/qmd/change',
        name: 'Änderungen',
        icon: 'mdi-account-convert-outline',
        component: () => import('../views/qmd/Change.vue'),
        meta: { right: 4 },
      },
    ],
  },
  // search
  {
    path: '/search',
    name: 'search',
    redirect: '/search/article',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/search/article',
        name: 'Artikel',
        icon: 'mdi-list-box-outline',
        component: () => import('../views/search/Article.vue'),
        meta: { search: true, multiple: true },
      },
      {
        path: '/search/proofofuse',
        name: 'VN',
        icon: 'mdi-magnify',
        component: () => import('../views/search/ProofOfUse.vue'),
        meta: { search: true },
      },
      {
        path: '/search/freenumber',
        name: 'Nummer',
        icon: 'mdi-order-numeric-ascending',
        component: () => import('../views/search/FreeNumber.vue'),
        meta: { search: true, number: true },
      },
      {
        path: '/search/order',
        name: 'Bestellung',
        icon: 'mdi-clipboard-list-outline',
        component: () => import('../views/search/Order.vue'),
        meta: { right: 4, search: true },
      },
      {
        path: '/search/wip',
        name: 'WIP',
        icon: 'mdi-progress-question',
        component: () => import('../views/search/Wip.vue'),
        meta: { right: 8, search: true },
      },
      {
        path: '/search/mpos',
        name: 'M-Pos',
        icon: 'mdi-text-box-check-outline',
        component: () => import('../views/search/Mpos.vue'),
        meta: { right: 16 },
      },
      {
        path: '/search/missing',
        name: 'Fehlteile',
        icon: 'mdi-text-box-minus-outline',
        component: () => import('../views/search/MissingParts.vue'),
        meta: { right: 32, search: true },
      },
      {
        path: '/search/need',
        name: 'XXX',
        icon: 'mdi-exclamation',
        component: () => import('../views/search/NeedsAssessment.vue'),
        meta: { right: 32, search: true },
      },
    ],
  },
  // time
  {
    path: '/time',
    name: 'time',
    redirect: '/time/overview',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/time/overview',
        name: 'Übersicht',
        icon: 'mdi-file-outline',
        component: () => import('../views/time/Overview.vue'),
        meta: { search: true },
      },
      {
        path: '/time/userview',
        name: 'User',
        icon: 'mdi-account-outline',
        component: () => import('../views/time/Userview.vue'),
      },
      {
        path: '/time/rental',
        name: 'Verleih',
        icon: 'mdi-open-in-new',
        component: () => import('../views/time/Rental.vue'),
        meta: { right: 17 }, // 1 & 16
      },
      {
        path: '/time/groups',
        name: 'Gruppen',
        icon: 'mdi-group',
        component: () => import('../views/time/Groups.vue'),
        meta: { right: 17 }, // 1 & 16
      },
      {
        path: '/time/evaluation',
        name: 'Auswertung',
        icon: 'mdi-chart-bar',
        component: () => import('../views/time/Evaluation.vue'),
        meta: { right: 17 }, // 1 & 16
      },
    ],
  },
  // uro
  {
    path: '/uro',
    name: 'uro',
    redirect: '/uro/overview',
    component: () => import('../components/AppHome.vue'),
    children: [
      {
        path: '/uro/overview',
        name: 'Übersicht',
        icon: 'mdi-file-outline',
        component: () => import('../views/uro/Overview.vue'),
        meta: { search: true },
      },
    ],
  },
  { path: '*', redirect: '/' },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach(async (to, from, next) => {
  var app = to.matched[0].name
  // set tab title
  document.title = to.meta.title ? to.meta.title : to.name
  // login
  if (to.path == '/login') return next()
  // load user data
  if (!store.getters.user) {
    if (store.state.loggedIn != '' || (await store.dispatch('hasCookie')))
      await store.dispatch('loadUserData')
  }
  // check rights
  if (store.getters.user) {
    let appRight = store.getters.user.rights[app]

    if (to.path == '/') {
      // delete values for home screen
      delete store.getters.user.app
      next()
    } else if (appRight == 0) {
      store.commit(
        'setMessage',
        'Keine Berechtigung für die gewünschte Weiterleitung.'
      )
      next('/')
    } else {
      // init new app
      if (store.getters.user.app?.title != app) {
        store.commit('setUserCurrentApp', app)
        await initApp(app)
      }
      // check if app disabled
      if (store.getters.user.app?.disabled && !to.path.match(/admin/)) {
        store.commit(
          'setMessage',
          'Die ausgewählte Anwendung ist aktuell gesperrt.'
        )
        next('/')
      }
      // check if has limited rights in app
      else if (!(appRight & to.meta.right) && to.meta.right !== undefined) {
        let newPath = ''
        let childs = routes.find((r) => r.name == app).children

        newPath = childs.find(
          (e) => appRight & e?.meta?.right && !e.children
        )?.path

        if (newPath === undefined)
          childs.forEach((el) => {
            if (el.children)
              newPath = el.children.find(
                (e) => appRight & e?.meta?.right && !e.children
              )?.path
          })

        if (newPath === undefined) {
          store.commit(
            'setMessage',
            'Es ist ein interner Fehler aufgetreten. Bitte informieren sie den Entwickler.'
          )
          router.push('/').catch(() => {})
        } else router.push(newPath)
      } else {
        // save userclick for statistic
        store.dispatch('saveUserClick', {
          app: app,
          page: to.name,
        })

        next()
      }
    }
  } else {
    if (to.path != '/') {
      store.commit(
        'setMessage',
        'Zum Arbeiten mit der gewählten Anwendung bitte erst anmelden.'
      )
      store.commit('setRedirectPath', to.path)
    }
    next('/login')
  }
})

// init
export const initApp = async function (app) {
  console.log('init ', app)
  switch (app) {
    case 'crm':
      // await store.dispatch('crm/checkRights')
      await store.dispatch('crm/getSpecialRights')
      break
    case 'pda':
      break
    case 'plan':
      await store.dispatch('plan/loadInitData')
      break
    case 'prm':
      await store.dispatch('prm/loadInitData')
      break
    case 'ptb':
      await store.dispatch('ptb/loadInitData')
      break
    case 'qmd':
      await store.dispatch('qmd/loadDocList')
      break
    case 'time':
      await store.dispatch('time/loadGroups')
      break
    default:
      break
  }
}

export default router
